import { render, staticRenderFns } from "./FrequencyDocumentSaveModal.vue?vue&type=template&id=c379a0de&scoped=true"
import script from "./FrequencyDocumentSaveModal.vue?vue&type=script&lang=ts"
export * from "./FrequencyDocumentSaveModal.vue?vue&type=script&lang=ts"
import style0 from "./FrequencyDocumentSaveModal.vue?vue&type=style&index=0&id=c379a0de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c379a0de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c379a0de')) {
      api.createRecord('c379a0de', component.options)
    } else {
      api.reload('c379a0de', component.options)
    }
    module.hot.accept("./FrequencyDocumentSaveModal.vue?vue&type=template&id=c379a0de&scoped=true", function () {
      api.rerender('c379a0de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency-documents/FrequencyDocumentSaveModal.vue"
export default component.exports